import { Component, ElementRef, ViewChild } from '@angular/core';
import { appInjector } from '../../shared/app-injector';
import { BaseComponent } from '../../shared/base-components/base.component';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { ChannelService } from '../../shared/services/realtime-messaging/channel.service';
import { AppSettings } from '../../shared/settings/app-settings.model';
import { NotificationService } from '../services/notification.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'notification-count',
    template: '{{messageCount}}'
})

export class NotificationRealtimeMessageComponent extends BaseComponent {
    public messageCount = '';
    private token: string;
    public notificationService: NotificationService;
    @ViewChild('cookieFrame', { static: true }) cookieFrame: ElementRef;
    private notificationsCount$: Observable<string>;

    constructor(
        public modalService: MvdModalService,
        public settings: AppSettings,
        private channelService: ChannelService
    ) {
        super();
    }

    ngOnInit() {
        this.auth.initializeAcquireToken().subscribe(
            token => {
                if (token != undefined && token.length > 0) {
                    this.token = token;
                    this.loadNotifications();
                } else {
                    console.log('Invalid token for notifications');
                }
            },
            err => {
                console.log(err);
            }
        );
    }

    ngOnDestroy() {
        this.channelService.unbindConnectionMessage('realtimehub', 'NotificationAlert', this.showNotificationAlert);
        this.channelService.unbindConnectionMessage('realtimehub', 'NotificationCount', this.incrementNotificationCount);
        super.ngOnDestroy();
    }

    /**
     * Resolves reference to the notification service.  This is needed (rather than normal DI approach) due to how early notification
     *  pieces load relative to the rest of the application.
     */
    getNotificationService(): NotificationService {
        if (!this.notificationService) {
            var injector = appInjector();
            this.notificationService = <NotificationService> injector.get(NotificationService);
        }
        return this.notificationService;
    }

    /**
     * Loading notifications after logged in successfully
     */
    loadNotifications(): void {
        if (this.token && (this.settings.api.signalrIntegration === 'true')) {
            this.getNotificationService().getAlerts().subscribe(result => {

                var alerts = result.result;

                for (const alert of alerts) {
                    this.popAlert(alert.notificationMessageData.messageText, alert.notificationMessageData.notificationMessageDispositionId);
                }
            });

            // subscribe to notification count to update when business unit changed
            this.auth.notificationsCount.subscribe(result => {
                this.messageCount = result;
            });

            this.channelService.bindConnectionMessage('realtimehub', 'NotificationAlert', this.showNotificationAlert);
            this.channelService.bindConnectionMessage('realtimehub', 'NotificationCount', this.incrementNotificationCount);
        }
    }

    /**
     * Increments the count of messages displayed on the notification center icon
     */
    incrementNotificationCount = (data) => {
        this.messageCount = this.countString(data);
    };

    countString(count: number): string {
        return count === 0 ? '' : `${count}`;
    }

    /**
     * Helper/callback method to break data object (composed of messageText, messageId, and redirctUrl) down for
     *  invocation of "popAlert" method
     * @param data - data object returned by realtime messaging engine
     */
    showNotificationAlert = (data) => {
        this.popAlert(data.messageText, data.messageId, data.redirectUrl);
    };

    /**
     * Pops up an alert message
     * @param messageText - Message text to be displayed
     * @param messageId - The notification message ID of the message, for flagging the item as deleted once read & dismissed
     * @param redirectUrl - optional redirection URL on message close
     */
    popAlert(messageText, messageId, redirectUrl = null) {
        // RH remove sanitized HTML from Alerts until receive confirmation from business
        // this.sanitized = this.domSanitizer.bypassSecurityTrustHtml(messageText);
        // const data = this.modalService.alert().title("Alert!").body(messageText);
        this.modalService.alert().title('Alert!').body(messageText)
            .open().afterClosed()
            .subscribe(() => {
                if (messageId) {
                    this.getNotificationService().markMessageRead(messageId).subscribe();
                }
                if (redirectUrl) {
                    window.location.href = redirectUrl;
                }
            });
    }
}
